// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3DTUJ","spin":"Spinner_spin__1pKVX","container":"Spinner_container__1INVF"};